import React, { Component } from 'react';
import { AbstractChart } from 'containers/charts/AbstractChart';
import { withTheme } from 'styled-components';
import { isEqual } from 'lodash';
import helpers from 'helpers';
import ContentTile from 'components/atoms/layout/ContentTile';
import ContentHeader from 'components/atoms/layout/ContentHeader';

class StackedBarChart extends Component {
    constructor(props) {
        super(props);
        this.chartRef = React.createRef();
    }

    shouldComponentUpdate(nextProps) {
        if (isEqual(nextProps.data, this.props.data)) {
            return false;
        }
        return true;
    }

    render() {
        // const intermediateSeries = [];
        const { rankedOrder, data, y, xAxisLabel, yAxisLabel, xAxisType, categories, title,
            caption, showTopN } = this.props;
        const { chartRef } = this;
        const { orderedColors } = this.props.theme;
        const keys = rankedOrder || Object.keys(data);
        const topNData = {};

        const intermediateSeries = keys.map((key, index) => {
            let completeData;
            if (!this.props.categories) {
                completeData = helpers.backfill(
                    data[key].map(r => ({ x: r.date_in_ms, y: r[y] })),
                    this.props.backfillBuckets
                );
            } else {
                completeData = data[key].map(r => r[y]);
            }

            const sumData = completeData.reduce((prev, curr) => prev + curr.y, 0);
            topNData[key] = sumData;
            return {
                name: helpers.convertToDisplayValue(key),
                color: orderedColors[index % orderedColors.length],
                data: completeData
            };
        });

        // if showTopN, then clean series and add totals line graph
        const series = showTopN ? helpers.getTopN(intermediateSeries, topNData, showTopN) : intermediateSeries;

        const xAxis = helpers.xAxisConfig({
            type: xAxisType,
            xAxisLabel,
            options: { categories }
        });

        const yAxis = helpers.yAxisConfig({ yAxisLabel: yAxisLabel || y });

        const plotOptions = {
            series: {
                animation: {
                    duration: this.props.animateDuration,
                }
            },
            column: {
                stacking: 'normal',
                borderWidth: 0
            }
        };

        return (
            <ContentTile padding={helpers.contentPadding('chart-with-legend')}>
                <ContentHeader chartRef={chartRef} type={'chart'}>{title}</ContentHeader>
                <AbstractChart
                    ref={chartRef}
                    exportName={this.props.exportName}
                    config={{
                        meta: { title },
                        chart: {
                            type: 'column'
                        },
                        exporting: helpers.commonExportingConfig(this.props.exportName),
                        credits: {
                            enabled: false
                        },
                        plotOptions,
                        title: {
                            text: null
                        },

                        tooltip: {
                            split: true,
                            crosshairs: {
                                width: 1,
                                color: 'gray',
                                dashStyle: 'shortdot'
                            },
                            formatter(tooltip) {
                                const items = this.points;
                                items.sort((a, b) => b.y - a.y);
                                return tooltip.defaultFormatter.call(this, tooltip);
                            },
                            ...(this.props.toolTipOptions || {})
                        },
                        xAxis,
                        yAxis,
                        series,
                        caption: {
                            text: caption
                        }
                    }} />
            </ContentTile>
        );
    }
}

export default withTheme(StackedBarChart);



// WEBPACK FOOTER //
// ./src/components/molecules/charts/StackedBarChart.js